import { Button, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';
import Image from '../../../../reusable-components/image';

ReportWillBeEmailedCard.propTypes = {
  back: PropTypes.func,
  backText: PropTypes.string,
};

export default function ReportWillBeEmailedCard({ back, backText }) {
 
  return <Paper sx={{ height: 'max(calc(100vh - 310px), 300px)', width: '100%', pt: 4, pl: 4, pr: 4 }}>
    <Button
      variant="text"
      onClick={back}
      startIcon={<Iconify icon="mingcute:left-fill" width={24} height={24} sx={{ mx: -1 }} />}
      sx={{ color: '#454F5B', fontWeight: 'bold' }}
    >
      {backText}
    </Button>

    <Typography sx={{ pt: 10, pb: 2, textAlign: 'center' }} variant="h6" color="info.main">
      Report will be emailed to you within a few minutes
    </Typography>
    <Image
      src="https://res.cloudinary.com/agoraserv/image/upload/v1745594200/SendingEmail.gif"
      sx={{ width: '10%', height: 'auto', marginLeft: '45%' }}
    />
  </Paper>;
}